/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MANAGER_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getVersion",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "increment",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class BaseContractImpl__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
BaseContractImpl__factory.bytecode = _bytecode;
BaseContractImpl__factory.abi = _abi;
//# sourceMappingURL=BaseContractImpl__factory.js.map